import { BaseEntity } from "@app/models/rest/base-entity";
import {
  HateoasProjection,
  HateoasResource,
  ProjectionRel
} from "@lagoshny/ngx-hateoas-client";
import { PlanningSegmentRuleMode } from "@app/models/enums/planning-segment-rule.enum";
import { Priority } from "@app/models/rest/priority";

@HateoasResource("planningSegments")
export class PlanningSegment extends BaseEntity {
  description: string;
  code: string;
  startHour: number;
  startMinute: number;
  duration: number;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
  showForNormal: boolean;
  showForHigh: boolean;
  showForEmergency: boolean;
  @ProjectionRel(Priority)
  filterPriorities: Priority[];
}

@HateoasProjection(PlanningSegment, "detail")
export class PlanningSegmentDetail extends BaseEntity {
  description: string;
  code: string;
  startHour: number;
  startMinute: number;
  duration: number;
  monday: boolean;
  tuesday: boolean;
  wednesday: boolean;
  thursday: boolean;
  friday: boolean;
  saturday: boolean;
  sunday: boolean;
  showForNormal: boolean;
  showForHigh: boolean;
  showForEmergency: boolean;
  codeMode: PlanningSegmentRuleMode;

  @ProjectionRel(Priority)
  filterPriorities: Priority[];
}
